(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faqs-main"] && !window.DesignMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    var previousPage = document.referrer;

    // Check if the previous page URL contains '/products/' indicating it's a product page
    var isProductPage = previousPage.includes('/products/');

    if (isProductPage) {
      var accordionHeaders = document.querySelectorAll('.faqs-main__category .faqs-main__faq:last-child');

      // Add open-class to each accordion header
      accordionHeaders.forEach(function(header) {
        header.classList.add('accordion--open');
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product-slider"] && !window.DesignMode) return;
  try {
    
        document.addEventListener("DOMContentLoaded", function() {
      var productInfos = document.querySelectorAll('.vd-product-info');

      productInfos.forEach(function(productInfo) {
          var expandButton = productInfo.querySelector('.expand-button');

          // Check the height of the div
          if (productInfo.scrollHeight > 50) {
              expandButton.style.display = 'flex';
          }

          // Add event listener to the button
          expandButton.addEventListener('click', function() {
              productInfo.classList.toggle('expanded');
          });
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multiple-image-section"] && !window.DesignMode) return;
  try {
    
  document.getElementById('viewAllBtn').addEventListener('click', function() {
    document.getElementById('hiddenImages').style.display = 'grid';
    document.getElementById('viewAllBtnwrapper').style.display = 'none';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["QR-banner"] && !window.DesignMode) return;
  try {
    
  // document.addEventListener('DOMContentLoaded', function() {
  //   document.querySelectorAll('.scroll-link').forEach(function(anchor) {
  //     anchor.addEventListener('click', function(e) {
  //       e.preventDefault();

  //       const targetId = this.getAttribute('href').substring(1);
  //       const targetElement = document.getElementById(targetId);

  //       if (targetElement) {
  //         const offsetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - 85;

  //         window.scrollTo({
  //           top: offsetPosition,
  //           behavior: 'smooth'
  //         });
  //       }
  //     });
  //   });
  // });
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.scroll-link').forEach(function(anchor) {
      anchor.addEventListener('click', function(e) {
        e.preventDefault();

        const targetId = this.getAttribute('href').substring(1);
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
          // Scroll to the element with an offset of 90px
          const offsetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - 90;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });

          // Add the 'open' attribute to the target element
          targetElement.setAttribute('open', '');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["welcome-kit"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {

   window.addEventListener("klaviyoForms", function(e) {  
      if (e.detail.type == 'submit') {
          const welcomeKit = document.querySelector('.welcome-kit-wrapper');
          if (welcomeKit) {
              welcomeKit.classList.remove('d-none');
              
              // Get the element's position
              const elementPosition = welcomeKit.getBoundingClientRect().top + window.scrollY;
              
              // Scroll to element position minus 50px
              window.scrollTo({
                  top: elementPosition,
                  behavior: 'smooth'
              });
          }
      }
  });
  
   const allSliders = document.querySelectorAll('.slider');
   const inputs = document.querySelectorAll('input[name="nutrition"], input[name="multivitamin"]');

   inputs.forEach(input => {
       input.addEventListener('change', function() {
           const nutritionInput = document.querySelector('input[name="nutrition"]:checked');
           const multivitaminInput = document.querySelector('input[name="multivitamin"]:checked');
           
           if (nutritionInput && multivitaminInput) {
               const nutritionTab = nutritionInput.getAttribute('data-tab-name');
               const multivitaminTab = multivitaminInput.getAttribute('data-tab-name');
               let variantId;
               console.log('Raw values:', JSON.stringify(nutritionTab), JSON.stringify(multivitaminTab));

               if (nutritionTab === 'option1' && multivitaminTab === 'option1') {
                   variantId = '54924885590396';
               } else if (nutritionTab === 'option2' && multivitaminTab === 'option1') {
                   variantId = '54924891062652';
               } else if (nutritionTab === 'option1' && multivitaminTab === 'option2') {
                   variantId = '54924895650172';
               } else if (nutritionTab === 'option2' && multivitaminTab === 'option2') {
                   variantId = '54924898402684';
               }
               if (variantId) {
                   const idInput = document.querySelector('#product_main_form input[name="id"]');
                   if (idInput) idInput.value = variantId;
               }
           }

           const sliderId = this.getAttribute('data-slider');
           if (sliderId) {
              allSliders.forEach(slider => slider.classList.add('hide-slider'));
               const targetSlider = document.querySelector(`.${sliderId}`);
               if (targetSlider) targetSlider.classList.remove('hide-slider');
           }
       });
   });
});

  } catch(e) { console.error(e); }
})();
})();
